import { Injectable } from '@angular/core';
import { Config } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
  useExisting: Config,
})
export abstract class IconConfig {
  icon?: IconOptions;
}

declare module '@spartacus/core' {
  interface Config extends IconConfig {}
}

export interface IconOptions {
  symbols?: {
    [ICON_TYPE: string]: string;
  };

  resources?: IconConfigResource[];
}

export interface IconConfigResource {
  type: IconResourceType | string;
  url?: string;
  types?: string[];
}

export enum IconResourceType {
  SVG = 'svg',
}
